import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=1663e0e6&"
import script from "./AddButton.vue?vue&type=script&lang=ts&"
export * from "./AddButton.vue?vue&type=script&lang=ts&"
import style0 from "./AddButton.vue?vue&type=style&index=0&id=1663e0e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports